import { createContext, useEffect, useReducer } from 'react';

import { type CardHeaderEditReducerAction, type CardHeaderEditState, reducer } from './reducer';

const initialState: CardHeaderEditState = {};
const intialValue: [CardHeaderEditState, React.Dispatch<CardHeaderEditReducerAction>] = [
  initialState,
  () => {
    console.warn('Card Header Edit reducer not enabled.');
  },
];

export const CardHeaderEditContext = createContext(intialValue);

interface CardHeaderEditProviderProps {
  appliedPresetId?: string | undefined;
}
const CardHeaderEditProvider: React.FC<React.PropsWithChildren<CardHeaderEditProviderProps>> = ({
  children,
  appliedPresetId,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  // allow the parent component to update the preset ID via a prop.
  useEffect(() => {
    if (state.appliedPresetId !== appliedPresetId) {
      dispatch({ type: 'SET_PRESET_ID', value: appliedPresetId });
    }
  }, [appliedPresetId, state.appliedPresetId]);

  return (
    <CardHeaderEditContext.Provider value={[state, dispatch]}>{children}</CardHeaderEditContext.Provider>
  );
};

export default CardHeaderEditProvider;
